<template>
  <div class="c-personal-wrapper" :aaa="gamePaybackOptions.height">
    <!-- filter -->
    <game-filter
      slot="filter"
      :game-data="mGameData"
      @on-add="visible = true"
      @on-down="downExcel"
      @on-import="importExcel"
      @on-change="filterData"
    />
    <div class="__table tasks-table">
      <Viewport v-model="gamePaybackOptions.height">
        <vxe-grid v-bind="gamePaybackOptions" ref="gamePaybackTable">
          <!-- 操作列 -->
          <template #operation="{ row }">
            <Poptip confirm transfer title="您确认删除该游戏回款设置吗？" @on-ok="delClick(row)">
              <el-button type="text">删除</el-button>
            </Poptip>
            <el-button type="text" @click.prevent="editClick(row)">修改</el-button>
          </template>
        </vxe-grid>
        <Page
          show-total
          show-sizer
          show-elevator
          class="pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
        />
      </Viewport>
    </div>

    <Modal
      v-model="visible"
      :title="title"
      :width="520"
      :mask-closable="false"
      class-name="vertical-center-modal"
      @on-visible-change="bindGetData"
    >
      <div class="m-form">
        <Form :label-width="180">
          <FormItem label="天数">
            <Select v-model="paybackStand.seriesNo" :disabled="editble" placeholder="请选择天数" style="width: 180px">
              <Option :value="idx + 1" :label="idx + 1" v-for="(seriesNo, idx) in 31" :key="idx + 1"></Option>
            </Select>
          </FormItem>
          <FormItem label="中间件游戏">
            <Select v-model="paybackStand.mgameId" :disabled="editble" filterable placeholder="请选择中间件游戏" style="width: 180px">
              <Option :value="game.id" :label="game.name" v-for="(game, idx) in mGameData" :key="idx + 1"></Option>
            </Select>
          </FormItem>
          <FormItem label="平台">
            <Select v-model="paybackStand.platform" :disabled="editble" placeholder="请选择平台" style="width: 180px">
              <Option :value="platform.id" :label="platform.name" v-for="(platform, idx) in platformData" :key="idx + 1"></Option>
            </Select>
          </FormItem>
          <FormItem label="合格标准（自然日）">
            <Input-number-plus
              v-model="paybackStand.naturePassStd"
              placeholder="0.01-999.99"
              :min="0.01"
              :maxNum="999.99"
              :precision="2"
              style="width: 180px"
            />
            <span> %</span>
          </FormItem>
          <FormItem label="优秀标准（自然日）">
            <Input-number-plus
              v-model="paybackStand.natureExcellentStd"
              placeholder="0.01-999.99"
              :min="0.01"
              :maxNum="999.99"
              :precision="2"
              style="width: 180px"
            />
            <span> %</span>
          </FormItem>
          <FormItem label="卓越标准（自然日）">
            <Input-number-plus
              v-model="paybackStand.natureOutstandingStd"
              :min="0.01"
              :maxNum="999.99"
              :precision="2"
              placeholder="0.01-999.99"
              style="width: 180px"
            />
            <span> %</span>
          </FormItem>
          <FormItem label="合格标准（周期日）">
            <Input-number-plus
              v-model="paybackStand.periodPassStd"
              placeholder="0.01-999.99"
              :min="0.01"
              :maxNum="999.99"
              :precision="2"
              style="width: 180px"
            />
            <span> %</span>
          </FormItem>
          <FormItem label="优秀标准（周期日）">
            <Input-number-plus
              v-model="paybackStand.periodExcellentStd"
              placeholder="0.01-999.99"
              :min="0.01"
              :maxNum="999.99"
              :precision="2"
              style="width: 180px"
            />
            <span> %</span>
          </FormItem>
          <FormItem label="卓越标准（周期日）">
            <Input-number-plus
              v-model="paybackStand.periodOutstandingStd"
              placeholder="0.01-999.99"
              :min="0.01"
              :maxNum="999.99"
              :precision="2"
              style="width: 180px"
            />
            <span> %</span>
          </FormItem>
        </Form>
      </div>
      <template slot="footer">
        <div class="m-foot">
          <Button @click="visible = false">取消</Button>
          <Button type="primary" :loading="saving" @click="handleSubmit">
            <span v-if="saving">提交中...</span>
            <span v-else>确认</span>
          </Button>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { isArray, isEmpty, timeout } from '@/common/js/utils'
import { HOST_API } from '@/api/config'
import { platformData } from '../data/platformData.js'
import { gamePaybackOptions } from '../data/opts.js'
import InputNumberPlus from '@/components/input/input-number-plus.vue'
import GameFilter from './components/game-filter'
import tableMixin from '../gamepayback/mixin_table'

import { getMiddleGameList } from '@/api/common.model'
import { addOrUpdateGameRoi, getGameRoiPage, importGameRoi, getGameRoi, delGameRoi } from '@/api/report.model'

const makePayForm = () => {
  return {
    seriesNo: null,
    mgameId: null,
    platform: null,
    naturePassStd: null,
    natureExcellentStd: null,
    natureOutstandingStd: null,
    periodPassStd: null,
    periodExcellentStd: null,
    periodOutstandingStd: null
  }
}
export default {
  name: 'GameRoi',
  mixins: [tableMixin],
  components: {
    GameFilter,
    InputNumberPlus
  },
  computed: {
    title() {
      return this.editble ? '修改回款标准' : '新建回款标准'
    }
  },
  data() {
    return {
      height: 0,
      columns: [],
      tableData: [],
      tableColumns: [],
      mGameData: [],
      projectGroupData: [],
      saving: null,
      visible: null,
      editble: null,
      paybackStand: makePayForm(),
      resultModel: null,
      success: 0,
      failure: 0,
      platformData,
      gamePaybackOptions
    }
  },
  methods: {
    bindGetData(val) {
      if (!val) {
        this.editble = val
        timeout(300).then(() => {
          this.paybackStand = makePayForm()
        })
      }
    },
    importExcel(file) {
      this.$Spin.show()
      importGameRoi({ file }).then((data) => {
        this.$Spin.hide()
        if (data) {
          this.failure = data.failTotal
          this.success = data.successTotal
          this.$Modal.info({
            title: '导入结果',
            width: 520,
            content: `成功${this.success}条，失败${this.failure}条`,
            okText: this.failure ? '下载失败数据' : '知道了',
            onOk: () => {
              if (this.failure) this.downFail()
              else this.resultOk()
            }
          })
        }
      })
    },
    downExcel() {
      window.open(`${HOST_API}/api/ptom/template/downTemplate?templateType=template_ptom_game_roi_config`, '_blank')
    },
    downFail() {
      window.open(`${HOST_API}/api/ptom/xlssettings/gameroi/downerror`, '_blank')
    },
    resultOk() {
      this.resultModel = false
      this.pageIndex = 1
      this.getData()
    },
    delClick({ mgameId, seriesNo, platform }) {
      delGameRoi({ mgameId, seriesNo, platform }).then((data) => {
        data && this.getData()
      })
    },
    editClick({ mgameId, seriesNo, platform }) {
      getGameRoi({ mgameId, seriesNo, platform }).then((data) => {
        if (data) {
          this.paybackStand = data
          this.visible = true
          this.editble = true
        }
      })
    },
    handleGame(meta) {
      this.$set(this.paybackStand, 'designerId', meta.id)
    },
    handleSubmit() {
      const { naturePassStd, natureExcellentStd, natureOutstandingStd, periodPassStd, periodExcellentStd, periodOutstandingStd } =
        this.paybackStand
      const callFn = (data) => {
        this.saving = false
        data && (this.visible = false)
        data && this.getData()
      }
      const err = () => {
        this.saving = false
      }
      const validArray = Object.keys(this.paybackStand)
      const nullEl = validArray.find((v) => isEmpty(this.paybackStand[v]) || !this.paybackStand[v])
      if (nullEl) {
        let title
        const findField = this.gamePaybackOptions.columns.filter((g) => g.field === nullEl)
        if (findField.length) title = findField.pop().title
        else {
          if (nullEl === 'mgameId') title = '中间件游戏'
        }
        return this.$Message.error(`${title}不能为空！`)
      }

      if (naturePassStd > natureExcellentStd || natureExcellentStd > natureOutstandingStd) {
        return this.$Message.error('自然日的合格目标、优秀目标、卓越目标需按递增填写')
      }

      if (periodPassStd > periodExcellentStd || periodExcellentStd > periodOutstandingStd) {
        return this.$Message.error('周期日的合格目标、优秀目标、卓越目标需按递增填写')
      }

      this.saving = true
      const { mgameId, ...formParams } = {
        ...this.paybackStand,
        mGameId: this.paybackStand.mgameId
      }
      addOrUpdateGameRoi(formParams).then(callFn).catch(err)
    },
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getGameRoiPage(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { list, page_info } = data
            if (isArray(list) && page_info) {
              const { total_number } = page_info
              this.tableColumns = this.gamePaybackOptions.columns
              this.gamePaybackOptions.data = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
          }
        })
        .catch(() => {
          this.loading = false
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    preloadData() {
      Promise.all([getMiddleGameList()]).then((data) => {
        const [mGameData] = data
        isArray(mGameData) && (this.mGameData = mGameData)
        isArray(mGameData) && this.getData({})
      })
    }
  },
  created() {
    this.preloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-personal-wrapper {
  height: 100%;

  .c-control-margin {
    display: inline-block;
    margin-left: 8px;
  }

  .pager {
    padding: 5px 0;
    text-align: right;
  }

  ::v-deep .el-button {
    margin-right: 8px;
  }
}
</style>
